import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import UniversitiesPage from "./pages/UniversitiesPage";
import NursingInGermanyPage from "./pages/NursingInGermanyPage";
import WorkforceManagementPage from "./pages/WorkforceManagementPage";
import MBBSAbroadPage from "./pages/MBBSAbroadPage";
import PhDAdmissionsPage from "./pages/PhDAdmissionsPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/universities" element={<UniversitiesPage />} />
          <Route path="/nursing-in-germany" element={<NursingInGermanyPage />} />
          <Route path="/workforce-management" element={<WorkforceManagementPage />} />
          <Route path="/mbbs-abroad" element={<MBBSAbroadPage />} />
          <Route path="/phd-admissions" element={<PhDAdmissionsPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
